<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3043 15.4492H8.9043"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2604 11.4395H8.90442"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1604 8.3L14.4904 2.9C13.7604 2.8 12.9404 2.75 12.0404 2.75C5.75039 2.75 3.65039 5.07 3.65039 12C3.65039 18.94 5.75039 21.25 12.0404 21.25C18.3404 21.25 20.4404 18.94 20.4404 12C20.4404 10.58 20.3504 9.35 20.1604 8.3Z"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9336 2.83203V5.49303C13.9336 7.35103 15.4396 8.85603 17.2976 8.85603H20.2486"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
